import { IChronologicalData, INameValue, IPaginationParams, IPaginationResponse } from '@/models/general'
import { API } from './api'
import { Response } from './api'
import { ArticleStream } from './stream'

const ROOT_PATH = 'api/v1/keyword/'

interface AnalyticsParams {
  keyword: string
  startDate: string
  endDate: string
}

export type AnalyticsParamsWithPagination = AnalyticsParams & IPaginationParams

export interface ITalk {
  originalId: string
  socialMedia: string
  displayPicture: string
  fromName: string
  content: string
  link: string
  timestamp: string
  likeCount: number
  shareCount: number
  viewCount: number
  commentCount: number
  engagement: number
}

interface ListOfTalkResponse {
  isLock: boolean
  data: IPaginationResponse<ITalk>
}

export interface Talker {
  comment: number
  engagement: number
  followers: number
  fromName: string
  like: number
  share: number
  socialMedia: string
  talk: number
  value: number
  view: number
  following: number
  // openness: number | null;
  // conscientiousness: number | null;
  // extraversion: number | null;
  // agreeableness: number | null;
  // neuroticism: number | null;
}

interface TopTalkerResponse {
  isLock: boolean
  data: Talker[]
}

interface WordCloudResponse {
  isLock: boolean
  data: INameValue[]
}

interface NameValueResponse {
  isLock: boolean
  data: INameValue
}

interface NewsPortalArticleResponse {
  isLock: boolean
  data: IChronologicalData[]
}

interface ArticleByMediaData {
  media: string
  total: number
}

interface ArticleByMediaResponse {
  isLock: boolean
  data: ArticleByMediaData[]
}

interface OnmStreamResponse {
  isLock: boolean
  data: IPaginationResponse<ArticleStream>
}

export const getTotalTalk = async (params: AnalyticsParams) => {
  try {
    const response = await API(`${ROOT_PATH}total_talk`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getTotalTalker = async (params: AnalyticsParams) => {
  try {
    const response = await API(`${ROOT_PATH}total_talker`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getPositiveTalk = async (params: AnalyticsParams) => {
  try {
    const response = await API(`${ROOT_PATH}positive_talk`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getNegativeTalk = async (params: AnalyticsParams) => {
  try {
    const response = await API(`${ROOT_PATH}negative_talk`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getDayToDayConversation = async (params: AnalyticsParams) => {
  try {
    const response = await API(`${ROOT_PATH}day_to_day_conversation`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getListOfTalk = async (params: AnalyticsParamsWithPagination): Promise<Response<ListOfTalkResponse>> => {
  try {
    const response = await API<ListOfTalkResponse>(`${ROOT_PATH}list_of_talk`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getTopTalker = async (params: AnalyticsParams): Promise<Response<TopTalkerResponse>> => {
  try {
    const response = await API<TopTalkerResponse>(`${ROOT_PATH}top_talker`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getWordCloud = async (params: AnalyticsParams): Promise<Response<WordCloudResponse>> => {
  try {
    const response = await API<WordCloudResponse>(`${ROOT_PATH}word_cloud`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getTotalArticle = async (params: AnalyticsParams): Promise<Response<NameValueResponse>> => {
  try {
    const response = await API<NameValueResponse>(`${ROOT_PATH}total_article`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getTotalMedia = async (params: AnalyticsParams): Promise<Response<NameValueResponse>> => {
  try {
    const response = await API<NameValueResponse>(`${ROOT_PATH}total_media`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getNewsPortalArticle = async (params: AnalyticsParams): Promise<Response<NewsPortalArticleResponse>> => {
  try {
    const response = await API<NewsPortalArticleResponse>(`${ROOT_PATH}news_portal_article`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getArticleByMedia = async (params: AnalyticsParams): Promise<Response<ArticleByMediaResponse>> => {
  try {
    const response = await API<ArticleByMediaResponse>(`${ROOT_PATH}article_by_media`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getWordCloudOnm = async (params: AnalyticsParams): Promise<Response<WordCloudResponse>> => {
  try {
    const response = await API<WordCloudResponse>(`${ROOT_PATH}word_cloud_onm`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}

export const getOnmStream = async (params: AnalyticsParamsWithPagination): Promise<Response<OnmStreamResponse>> => {
  try {
    const response = await API<OnmStreamResponse>(`${ROOT_PATH}stream_online_media`, 'GET', params, null)
    return response
  } catch (error) {
    return error
  }
}
